var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagFr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -4 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1310_8031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.999 0H-0.000976562V20H27.999V0Z",
    fill: "url(#paint0_linear_1310_8031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.999 0H13.3324V20H27.999V0Z",
    fill: "url(#paint1_linear_1310_8031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33236 0H-0.000976562V20H9.33236V0Z",
    fill: "url(#paint2_linear_1310_8031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6657 0H9.33237V20H18.6657V0Z",
    fill: "url(#paint3_linear_1310_8031)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1310_8031",
    x1: 13.999,
    y1: 0,
    x2: 13.999,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1310_8031",
    x1: 20.6657,
    y1: 0,
    x2: 20.6657,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE2A39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1310_8031",
    x1: 4.66569,
    y1: 0,
    x2: 4.66569,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1035BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#042396"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1310_8031",
    x1: 13.999,
    y1: 0,
    x2: 13.999,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1310_8031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFr);
export default __webpack_public_path__ + "static/media/flag-fr.0e07b5b0d12fcc556b95daf09601c092.svg";
export { ForwardRef as ReactComponent };